import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare var $: any;

@Component({
    selector: 'pnx-igtexteditor',
    templateUrl: './igtexteditor.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => IGTextEditorControl), multi: true }
    ]
})
export class IGTextEditorControl implements OnInit, ControlValueAccessor {

    @Input('value') _value;
    @Input() txtId;
    @Output() onChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() maxlength: number = 0;

    txtContent: string;

    txtMaxlengthIndicator: number = 0;

    constructor() { }

    ngOnInit() {
        this.initializeTxtEditor(this.txtId);
    }

    ngAfterViewInit() { }

    initializeTxtEditor(itxt) {
        var self = this;
        $(function () {
            var height = $('html').hasClass('touch') ? 500 : 430;
            $("#htmlEditor" + itxt).igHtmlEditor({
                height: height,
                width: "100%"
            });

            self.setRemainingMaxLenthCharacter(self);

            var contentEditor = $("#htmlEditor" + itxt + "_editor");

            if (contentEditor.length > 0) {
                $(contentEditor[0].contentWindow.document).bind("keyup", function (e) {
                    self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
                });

                if (self.maxlength > 0) {

                    $(contentEditor[0].contentWindow.document).bind("keydown", function (e) {
                        if ((self.value && self.value.length >= 100) && self.isAllowEvent(e) == false) {
                            return false;
                        }
                        self.setRemainingMaxLenthCharacter(self);
                    });

                    $(contentEditor[0].contentWindow.document).bind("keyup", function (e) {
                        if ((self.value && self.value.length > 100) && self.isAllowEvent(e) == false) {
                            e.target.innerText = e.target.innerText.substring(0, 100);
                        }
                        self.setRemainingMaxLenthCharacter(self);
                        
                    });

                }
            }

            $("#htmlEditor" + itxt).on("ightmleditoractionexecuted", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorcut", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorcopy", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorpaste", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorundo", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });

            $("#htmlEditor" + itxt).on("ightmleditorredo", function (evt, ui) {
                self.setHtmlContent($("#htmlEditor" + itxt).igHtmlEditor("getContent", "html"));
            });
        });

    }

    setRemainingMaxLenthCharacter(self: any) {
        let outvalue: number = (self.value) ? parseInt(self.value.length) : 0;
        let result: number = self.maxlength - outvalue;
        this.txtMaxlengthIndicator = (result < 0) ? 0 : result;

        this.txtMaxlengthIndicator 
    }

    isAllowEvent(event: any): boolean {
        let allowEvent: boolean = false;
        //8 ==> backspace || 46 ==> Delete || 37|38|39|40 ==> Arrows

        if (event.keyCode == 8 || event.keyCode == 46 || (event.keyCode >= 35 && event.keyCode <= 40)) {
            allowEvent = true;
        }
        else {

            allowEvent = false;
        }

        return allowEvent;
    }

    setHtmlContent(html: string) {
        this.onChange.emit(html);
        this.value = html;
    }

    onChangeCb: (_: any) => void = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.onChangeCb(val);
    }

    writeValue(value): void {
        this.value = value;
        this.txtContent = this.value;
    }

    registerOnChange(fn: any): void {
        this.onChangeCb = fn;
    }

    registerOnTouched(fn: any): void { }

    setDisabledState(isDisabled: boolean): void { }

}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/igtexteditor.control.ts